import { render, staticRenderFns } from "./shipmentsInfoTable.vue?vue&type=template&id=661d9090&scoped=true&"
import script from "./shipmentsInfoTable.vue?vue&type=script&lang=js&"
export * from "./shipmentsInfoTable.vue?vue&type=script&lang=js&"
import style0 from "./shipmentsInfoTable.vue?vue&type=style&index=0&id=661d9090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661d9090",
  null
  
)

export default component.exports